import {createStore} from 'vuex';
import appWidget from './modules/appWidget';

const store = createStore({
	modules: {
		appWidget
	}
});

export default store;